import {AppButtonIcon} from "@components"
import {REAL_TIME_ROUTES} from "@constants"
import {Box} from "@mui/material"
import React from "react"


export default function actionsColumn() {
	return {
		name: "id_search",
		label: "Real Time Searches",
		options: {
			filter: false,
			customBodyRowRenderLite: value => <Box sx={{ textAlign: "center" }}>
				<AppButtonIcon
					sx={{
						width: "2rem",
						height: "2rem",
						borderColor: "info.main",
						fontSize: "1.4rem",
						color: "info.main",
					}}
					tooltip="View in Real Time Searches"
					icon="magnifying-glass-arrow-right"
					onClick={e => {
						window.open(`${REAL_TIME_ROUTES.SEARCHES_PATH}?idSearch=${value}`)
						if (e.ctrlKey) e.preventDefault()
					}}
				/>
			</Box>,
		},
	}
}